var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourLemon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99996 18.3334C5.39996 18.3334 1.66663 14.6084 1.66663 10.0001C1.66663 5.40008 5.39996 1.66675 9.99996 1.66675C14.6083 1.66675 18.3333 5.40008 18.3333 10.0001C18.3333 14.6084 14.6083 18.3334 9.99996 18.3334ZM12.6583 13.0917C12.7583 13.1501 12.8666 13.1834 12.9833 13.1834C13.1916 13.1834 13.4 13.0751 13.5166 12.8751C13.6916 12.5834 13.6 12.2001 13.3 12.0167L10.3333 10.2501V6.40008C10.3333 6.05008 10.05 5.77508 9.70829 5.77508C9.36663 5.77508 9.08329 6.05008 9.08329 6.40008V10.6084C9.08329 10.8251 9.19996 11.0251 9.39163 11.1417L12.6583 13.0917Z",
    fill: "#F4CE14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourLemon);
export default __webpack_public_path__ + "static/media/hour_lemon.761853c3c1a17a133c1ded1deaeac2a6.svg";
export { ForwardRef as ReactComponent };